/* Mostashop — interactions du thème. Aucune dépendance. */
(function () {
  'use strict';

  /* ---- Drapeaux : mode édition du thème, préférence de réduction des animations ---- */
  var DESIGN_MODE = document.documentElement.getAttribute('data-design-mode') === 'true';
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Mega menu : survol au bureau, accordéon au mobile ---- */
  function initNav() {
    var row = document.querySelector('[data-nav-row]');
    var burger = document.querySelector('[data-burger]');
    if (burger && row) {
      burger.addEventListener('click', function () {
        var open = row.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    var isTouch = window.matchMedia('(max-width: 900px)');
    document.querySelectorAll('[data-nav-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-nav-link]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        if (!isTouch.matches) return;
        if (!item.querySelector('.mega')) return;
        e.preventDefault();
        var wasOpen = item.classList.contains('is-open');
        document.querySelectorAll('[data-nav-item].is-open').forEach(function (n) { n.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
      item.addEventListener('focusin', function () { if (!isTouch.matches) item.classList.add('is-open'); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-nav-item].is-open').forEach(function (n) { n.classList.remove('is-open'); });
      }
    });
  }

  /* ---- FAQ : une réponse ouverte à la fois ---- */
  function initFaq() {
    document.querySelectorAll('[data-faq]').forEach(function (list) {
      list.querySelectorAll('[data-faq-q]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('[data-faq-row]');
          var open = row.classList.contains('is-open');
          list.querySelectorAll('[data-faq-row]').forEach(function (r) {
            r.classList.remove('is-open');
            var b = r.querySelector('[data-faq-q]');
            if (b) b.setAttribute('aria-expanded', 'false');
            var s = r.querySelector('[data-faq-sign]');
            if (s) s.textContent = '+';
          });
          if (!open) {
            row.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            var sign = row.querySelector('[data-faq-sign]');
            if (sign) sign.textContent = '−';
          }
        });
      });
    });
  }

  /* ---- Favoris : mémorisés dans le navigateur ---- */
  var FAV_KEY = 'mostashop:favoris';
  function readFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { return []; }
  }
  function initFavs() {
    var favs = readFavs();
    document.querySelectorAll('[data-fav]').forEach(function (btn) {
      var id = btn.getAttribute('data-fav');
      if (favs.indexOf(id) !== -1) { btn.classList.add('is-on'); btn.textContent = '♥'; }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var list = readFavs();
        var i = list.indexOf(id);
        if (i === -1) { list.push(id); btn.classList.add('is-on'); btn.textContent = '♥'; }
        else { list.splice(i, 1); btn.classList.remove('is-on'); btn.textContent = '♡'; }
        try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (err) {}
        var count = document.querySelector('[data-fav-count]');
        if (count) count.textContent = list.length ? '(' + list.length + ')' : '';
      });
    });
    var count = document.querySelector('[data-fav-count]');
    if (count) count.textContent = favs.length ? '(' + favs.length + ')' : '';
  }

  /* ---- Ajout rapide au panier depuis les cartes produit ---- */
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var label = btn.querySelector('[data-quick-add-label]');
      var defaultText = label ? label.textContent : btn.textContent;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.classList.contains('is-added') || btn.disabled) return;
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) { if (!res.ok) throw new Error('add failed'); return fetch('/cart.js'); })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var count = document.querySelector('.cart-count');
            if (count) count.textContent = cart.item_count;
            btn.classList.add('is-added');
            if (label) label.textContent = '✓ Ajouté';
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.disabled = false;
              if (label) label.textContent = defaultText;
            }, 1600);
          })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  /* ---- Chat ---- */
  function initChat() {
    var panel = document.querySelector('[data-chat-panel]');
    var launcher = document.querySelector('[data-chat-launcher]');
    if (!panel || !launcher) return;
    function open() { panel.hidden = false; launcher.hidden = true; var i = panel.querySelector('input'); if (i) i.focus(); }
    function close() { panel.hidden = true; launcher.hidden = false; launcher.focus(); }
    launcher.addEventListener('click', open);
    var x = panel.querySelector('[data-chat-close]');
    if (x) x.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
    var body = panel.querySelector('[data-chat-body]');
    var form = panel.querySelector('[data-chat-form]');
    var reply = panel.getAttribute('data-chat-reply') || 'Merci, un conseiller vous répond très vite.';
    function say(text, who) {
      if (!body) return;
      var el = document.createElement('span');
      el.className = 'chat-msg chat-msg--' + who;
      el.textContent = text;
      body.appendChild(el);
      body.scrollTop = body.scrollHeight;
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input');
        var v = (input.value || '').trim();
        if (!v) return;
        say(v, 'user');
        input.value = '';
        setTimeout(function () { say(reply, 'bot'); }, 600);
      });
    }
    panel.querySelectorAll('[data-chat-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        say(chip.textContent.trim(), 'user');
        setTimeout(function () { say(chip.getAttribute('data-chat-chip') || reply, 'bot'); }, 600);
      });
    });
  }

  /* ---- Modale de bienvenue : une fois par visiteur ---- */
  function initWelcome() {
    var box = document.querySelector('[data-welcome]');
    if (!box) return;
    var key = 'mostashop:bienvenue';
    var force = box.getAttribute('data-welcome') === 'always';
    var seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch (e) {}
    if (seen && !force) { box.remove(); return; }
    var delay = parseInt(box.getAttribute('data-delay') || '900', 10);
    setTimeout(function () { box.hidden = false; }, delay);
    function close() {
      box.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (e) {}
    }
    box.querySelectorAll('[data-welcome-close]').forEach(function (b) { b.addEventListener('click', close); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
  }

  /* ---- Galerie produit ---- */
  function initGallery() {
    var main = document.querySelector('[data-pdp-main]');
    if (!main) return;
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-pdp-thumb');
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (b) { b.classList.remove('is-on'); });
        btn.classList.add('is-on');
      });
    });
  }

  /* ---- Apparition au défilement : sections et cartes ---- */
  function initReveal() {
    if (DESIGN_MODE || REDUCED_MOTION || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.section, .tile, .card, .prod');
    if (!targets.length) return;
    document.documentElement.classList.add('reveal-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (el) {
      if (el.dataset.revealBound) return;
      el.dataset.revealBound = '1';
      el.classList.add('reveal');
      observer.observe(el);
    });
  }

  /* ---- Bouton retour en haut : apparaît après ~400px de défilement ---- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    function onScroll() {
      if (window.scrollY > 400) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: REDUCED_MOTION ? 'auto' : 'smooth' });
    });
  }

  /* ---- Parallaxe légère sur la bannière d'accueil : uniquement en mode image unique.
         Quand le bandeau est un carrousel (piste .hero-track présente), le glissement
         horizontal gère seul le mouvement pour éviter tout conflit de transform. ---- */
  function initParallax() {
    var hero = document.querySelector('.hero');
    var mediaBox = hero ? hero.querySelector('.hero-media') : null;
    if (!hero || !mediaBox || mediaBox.querySelector('.hero-track')) return;
    var img = mediaBox.querySelector('img');
    if (!img || DESIGN_MODE || REDUCED_MOTION || img.dataset.bound) return;
    img.dataset.bound = '1';
    var ticking = false;
    function update() {
      var rect = hero.getBoundingClientRect();
      var offset = Math.max(-24, Math.min(24, rect.top * -0.12));
      img.style.transform = 'translateY(' + offset + 'px)';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---- Carrousel du bandeau d'accueil : vrai glissement horizontal (translateX),
         boucle infinie via des clones invisibles en début/fin de piste. Le texte du
         bandeau (.hero-inner) n'est jamais touché par ce script : seule la piste
         d'images glisse, le texte reste fixe en superposition. ---- */
  function initHeroSlider() {
    var track = document.querySelector('[data-hero-carousel]');
    if (!track || track.dataset.bound) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 3) return; // 1 image réelle mini + 2 clones
    track.dataset.bound = '1';

    var mediaBox = track.parentElement;
    var dots = mediaBox ? Array.prototype.slice.call(mediaBox.querySelectorAll('[data-hero-dot]')) : [];
    var realCount = slides.length - 2;
    var index = 1; // position 0 = clone de la dernière image, 1 = première vraie image
    var intervalMs = parseInt(track.getAttribute('data-interval'), 10) || 5800;
    var timer = null;
    var resumeTimer = null;
    var visible = false;

    function place(i, animate) {
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
    }
    function setDot(realIndex) {
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === realIndex); });
    }
    function goTo(i) {
      index = i;
      place(index);
      setDot(((index - 1) % realCount + realCount) % realCount);
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      if (index === slides.length - 1) {
        index = 1;
        place(index, false);
        void track.offsetWidth;
      } else if (index === 0) {
        index = realCount;
        place(index, false);
        void track.offsetWidth;
      }
    });

    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    function startAutoplay() {
      stopAutoplay();
      if (DESIGN_MODE || REDUCED_MOTION || !visible) return;
      timer = setInterval(next, intervalMs);
    }
    function pauseThenResume() {
      stopAutoplay();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAutoplay, Math.max(intervalMs * 2, 6000));
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(i + 1);
        pauseThenResume();
      });
    });

    var startX = 0, dragging = false, swiped = false;
    mediaBox.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX; dragging = true; swiped = false;
    }, { passive: true });
    mediaBox.addEventListener('touchmove', function (e) {
      if (!dragging || !e.touches || e.touches.length !== 1) return;
      if (Math.abs(e.touches[0].clientX - startX) > 12) swiped = true;
    }, { passive: true });
    mediaBox.addEventListener('touchend', function (e) {
      if (!dragging) return;
      dragging = false;
      if (swiped) {
        var dx = e.changedTouches[0].clientX - startX;
        if (dx < 0) next(); else prev();
        pauseThenResume();
      }
    }, { passive: true });

    place(index, false);
    setDot(0);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) startAutoplay(); else stopAutoplay();
        });
      }, { threshold: 0.25 });
      io.observe(mediaBox);
    } else {
      visible = true;
      startAutoplay();
    }
  }

  /* ---- Carrousel des portraits de personnages (auto-adaptatif au nombre d'images) ---- */
  function initCharacterCarousels() {
    var roots = document.querySelectorAll('[data-char-carousel]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      if (root.dataset.carouselBound) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-char-slide]'));
      if (slides.length < 2) return; // une seule image : rien à faire, affichage statique
      root.dataset.carouselBound = '1';

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-char-dot]'));
      var link = root.querySelector('.card-media-link');
      var index = 0;
      var timer = null;
      var resumeTimer = null;
      var visible = false;
      var AUTOPLAY_MS = parseInt(root.getAttribute('data-interval'), 10) || 2500;
      var RESUME_MS = Math.max(AUTOPLAY_MS * 2, 5000);

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      }
      function next() { goTo(index + 1); }
      function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
      function startAutoplay() {
        stopAutoplay();
        if (DESIGN_MODE || REDUCED_MOTION || !visible) return;
        timer = setInterval(next, AUTOPLAY_MS);
      }
      function pauseThenResume() {
        stopAutoplay();
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(startAutoplay, RESUME_MS);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(i);
          pauseThenResume();
        });
      });

      /* Glissement tactile : swipe gauche = suivant, swipe droite = précédent */
      var startX = 0, startY = 0, dragging = false, swiped = false;
      root.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        dragging = true; swiped = false;
      }, { passive: true });
      root.addEventListener('touchmove', function (e) {
        if (!dragging || !e.touches || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) swiped = true;
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (!dragging) return;
        dragging = false;
        if (swiped) {
          var dx = e.changedTouches[0].clientX - startX;
          if (dx < 0) next(); else goTo(index - 1);
          pauseThenResume();
        }
      }, { passive: true });
      if (link) {
        link.addEventListener('click', function (e) {
          if (swiped) { e.preventDefault(); swiped = false; }
        });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            if (visible) startAutoplay(); else stopAutoplay();
          });
        }, { threshold: 0.25 });
        io.observe(root);
      } else {
        visible = true;
        startAutoplay();
      }
    });
  }

  /* ---- Compte : menu déroulant utilisateur ---- */
  function initAccountMenu() {
    document.querySelectorAll('[data-account-menu]').forEach(function (menu) {
      if (menu.dataset.bound) return;
      menu.dataset.bound = '1';
      var trigger = menu.querySelector('[data-account-trigger]');
      var dropdown = menu.querySelector('[data-account-dropdown]');
      if (!trigger || !dropdown) return;
      function close() {
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
      function toggle(e) {
        e.stopPropagation();
        var open = dropdown.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      trigger.addEventListener('click', toggle);
      document.addEventListener('click', function (e) {
        if (!menu.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  function boot() {
    initNav(); initFaq(); initFavs(); initChat(); initWelcome(); initGallery(); initQuickAdd();
    initReveal(); initBackToTop(); initParallax(); initHeroSlider(); initCharacterCarousels(); initAccountMenu();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();